import React from "react";
import { Box, Link } from "@mui/material";
import { styled } from "@mui/material/styles";

const FooterContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(1), // Reduced from 2 to 1
  padding: theme.spacing(2),
  backgroundColor: "#fff",
  borderTop: "1px solid #e5e7eb",
  flexWrap: "wrap",
  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(0.75), // Even smaller gap on mobile
    padding: theme.spacing(1.5),
  },
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: "none",
  fontSize: "0.875rem",
  whiteSpace: "nowrap", // Prevent link text from breaking
  "&:hover": {
    color: "#f97316",
    textDecoration: "underline",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.75rem", // Smaller font on mobile
  },
}));

const CopyrightText = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "0.875rem",
  whiteSpace: "nowrap", // Prevent copyright from breaking
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.75rem", // Smaller font on mobile
  },
}));

const Separator = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "0.875rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.75rem", // Smaller font on mobile
  },
}));

const Footer = () => {
  return (
    <FooterContainer>
      <CopyrightText>© Foodie Call 2025</CopyrightText>
      <Separator>|</Separator>
      <FooterLink
        href="/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </FooterLink>
      <Separator>|</Separator>
      <FooterLink href="/feedback" target="_blank" rel="noopener noreferrer">
        Submit Feedback
      </FooterLink>
    </FooterContainer>
  );
};

export default Footer;
